module.exports = __webpack_public_path__ + "img/delete.11d9bacc.svg";